export default "__VITE_ASSET__CkpBH1XZ__"